import { makeClient } from "../../lib/types/Client";
import { Paginate } from "../../lib/types/Paginate"
import {
  caseOf,
  maybe
} from "../../lib";

export default {
  state: {
    clients: {},
    loading: false,
    error: '',
    term: "",
    group: [],
    pagination: { ...Paginate.defaultState },
  },

  mutations: {
    update(state, { path, value }) {
      state[path] = value;
    },
  },

  getters: {
    clientsPerPage: ({ clients, pagination: { current } }) => clients[current],

    client: ({ clients }) => id => maybe(clients[id]),

    clients: ({ clients }) => clients,
   
    clientsLoading : ({ loading }) => loading,

    clientsError : ({ error }) => error,

    group : ({ group }) => group,

    term : ({ term }) => term,

    pagination: ({ pagination }) => pagination,

    // Even though we don't use these variable we need to include them
    // To access the rootGetter
    groupName: (state, getters, rootState, rootGetters) => id => (
      caseOf(rootGetters["storeGroups/groups"], {
        Done: groups => groups.find(group => group.id === id)?.name || "-",
        _: () => "-",
      })
    ),
  },

  actions: {
    async fetchClients({ commit, getters, state }, page = 1) {
      commit("update", { path: "loading", value: true });
      commit("update", { path: "error", value: "" });
      const params = {
        query: getters.term,
        group: getters.group,
        page,
      }
      const { pagination } = state;
      const url = "/clients";
      try {
        const response = await Paginate.setCurrentPage({ pagination, page, commit, url, params });
        if (!response) return;
        const { current_page, data } = response.data;
        let value = { [current_page]: data.map(makeClient) };
        if (current_page !== 1) {
          value = { ...state.clients, ...value };
        }
        commit("update", { path: "clients", value });
      } catch (error) {
        console.error(error);
        commit("update", { path: "error", value: error });
      } finally {
        commit("update", { path: "loading", value: false });
      }
    },
  },
};